import { SessionEvent } from '../ISessionEvent';

export enum SessionEndReason {
  SignOut = 'sign-out',
  SessionTimeout = 'timeout',
}
export class SessionEndedEvent extends SessionEvent {
  constructor(reason: SessionEndReason) {
    super('session-ended', {
      reason,
    });
  }
}
